"use client";

import type { ComponentProps, ComponentType, ReactNode } from "react";
import { useMDXComponents } from "nextra-theme-docs";

interface StepsProps {
  children: ReactNode;
}

/**
 * Steps component wrapper
 * Uses theme's Steps component through useMDXComponents hook
 */
export default function Steps({ children, ...props }: StepsProps & ComponentProps<"div">) {
  const components = useMDXComponents();
  const StepsComponent = (components as { Steps?: ComponentType<StepsProps> }).Steps;

  if (!StepsComponent) {
    // Fallback if Steps is not available
    return <div {...props}>{children}</div>;
  }

  return <StepsComponent {...props}>{children}</StepsComponent>;
}
